import React from 'react'
import Cookies from 'universal-cookie'
import { TimeLogModal } from '../../../widget/Components/Modals'
import { getBaseURL } from '../../../../GlobalComponents/URLs'
import DropdownMenu, { NestedDropdownMenu } from 'react-dd-menu'
import { sendLog } from '../../Logging/SendLog'
import { SvgIcon } from '@progress/kendo-react-common'
import { lockIcon } from '@progress/kendo-svg-icons'
import {
    modifyMissingRequiredLockLevelFields,
    numericStepToFixed,
    wordToBoolean,
    findCurrentLockLevel,
    updateLockedLevels,
    checkIfIsLocking,
    checkIfMoreThanOneLockIsUnlock,
} from './Helpers/FormContainerHelperFunctions'


const getSections = (data) => {
    const uniqueSections = []
    // map runs the provided inline function on every element of the array
    // the updated array is returned, but I don't need that in this instance
    data.FormSectionFieldValueView.map((item) => {
        if (!getExistingSection(uniqueSections, item.FormSectionId)) {
            uniqueSections.push({
                FormSectionId: item.FormSectionId,
                Section: item.Section,
                SectionOrderBy: item.SectionOrderBy,
            })
        }
        return null
    })
    // sort the array using the passed in function
    uniqueSections.sort(orderSections)
    // return the sorted array of unique formsection objects
    return uniqueSections
}

const getExistingSection = (dataToCheck, FormSectionId) => {
    return dataToCheck.find((x) => x.FormSectionId === FormSectionId)
}

const orderSections = (a, b) => {
    if (a.SectionOrderBy < b.SectionOrderBy) return -1
    if (a.SectionOrderBy > b.SectionOrderBy) return 1
    return 0
}

const handlePrint = (url, fieldChanged) => {
    if (fieldChanged) {
        alert('There are unsaved changes. Please save before printing.')
        return false
    }

    if (url === '') window.print(document.innerHTML)
    else document.location = url
}

const handleDelete = (formid, recordid, currentUser, versionNumber) => {
    // confirmation message
    if (!window.confirm('Are you sure you want to delete this record?')) {
        return
    }

    // save props.formId/recordId for use in fetch steps
    //const { formid, recordid } = props

    let logEntry = {
        Reason: currentUser + ' deleted record ' + recordid + 'at ' + new Date(),
        EventName: 'JS: Delete Record',
        Description: 'Delete Version:' + versionNumber,
        Username: currentUser,
    }
    sendLog(logEntry)

    // use fetch to DELETE form values
    fetch(`${getBaseURL()}webapi/form/record/${recordid}`, {
        method: 'DELETE',
        //headers: {
        //'Authorization': `bearer ${'token'}`,
        //'Content-Type': 'application/json',
        // allows webapi to check for cookies
        credentials: 'include',
        //}
    })
        .then(function (response) {
            if (response.ok) {
                return response.blob()
            }
            throw new Error('Network response was not ok.')
        })
        .then(function (myBlob) {
            // after successful delete, alert user and redirect to blank form
            prepDelete()
            alert('Delete Successful!')
            const url = `/FormGeneric/form/${formid}`
            document.location = url
        })
        .catch(function (error) {
            let logEntry = {
                Reason:
                    'Failed to delete at ' +
                    new Date() +
                    'error:' +
                    error.name +
                    ' ' +
                    error.message +
                    ' ' +
                    error.stack,
                EventName: 'JS Error: HandleDeleteCatch',
                Description:
                    'Initial Delete send failed. Error in HandleDelete Version' + versionNumber,
                Username: currentUser,
            }
            sendLog(logEntry)
        })
}

export const FormMenu = (
    data,
    setFormViewId,
    //handlePrint,
    recordId,
    formId,
    toggleMenu,
    closeMenu,
    lockState,
    numLevels,
    setCurrentModal,
    lockedLevelsArray,
    recordLockLevel,
    refRecordId,
    isMenuOpen,
    fieldChanged,
    currentUser,
    versionNumber,
    handleSign,
    lockedLevels,
    handleReadOnly,
    canUnlock,
    setShowConfirmModal
) => {
    const prehandleLock = (newRecordLevel, currentRecordLevel, excludingId, sourceSignature) => {
        if (checkIfMoreThanOneLockIsUnlock(lockedLevels, currentRecordLevel)) {
            handleSign(newRecordLevel, currentRecordLevel, excludingId, sourceSignature)()
        } else {
            alert('You can only have one level unlock at an the time')
        }
    }
    let toggle_dropdown_children = []
    toggle_dropdown_children.push(
        React.createElement(
            'span',
            {
                className: 'sr-only',
                key: 'sp1',
            },
            'Toggle Navigation'
        )
    )
    toggle_dropdown_children.push(
        React.createElement('span', {
            className: 'icon-bar',
            key: 'sp2',
        })
    )
    toggle_dropdown_children.push(
        React.createElement('span', {
            className: 'icon-bar',
            key: 'sp3',
        })
    )
    toggle_dropdown_children.push(
        React.createElement('span', {
            className: 'icon-bar',
            key: 'sp4',
        })
    )

    const menuOptions = {
        animate: 'false',
        delay: 0,
        entertimeout: 0,
        leavetimeout: 0,
        textalign: 'left',
    }

    const nestedMenuOptions = {
        // animate: false,
        // delay: 0
    }

    let dropdown_menu_items = []

    if (recordId > -1) {
        const cookies = new Cookies(document.cookie)
        let view_menu_items = []

        view_menu_items.push(
            React.createElement(
                'li',
                {
                    key: 'dropdown_menu_view_li',
                    onClick: () => {
                        cookies.remove(`formViewId${formId}`)
                        setFormViewId(0)
                    },
                },
                React.createElement(
                    'a',
                    {
                        href: '#',
                        key: 'dropdown_menu_view_a',
                    },
                    'Default'
                )
            )
        )

        data.FormView.forEach((view, jx) => {
            view_menu_items.push(
                React.createElement(
                    'li',
                    {
                        key: `dropdown_menu_view_li${jx}`,
                        onClick: () => {
                            setFormViewId(view.FormViewId)
                            let aYearFromNow = new Date()
                            aYearFromNow.setFullYear(aYearFromNow.getFullYear() + 1)
                            cookies.set(`formViewId${formId}`, view.FormViewId, {
                                expires: aYearFromNow,
                            })
                        },
                    },
                    React.createElement(
                        'a',
                        {
                            href: '#',
                            key: `dropdown_menu_view_a${jx}`,
                        },
                        view.Name
                    )
                )
            )
        })

        dropdown_menu_items.push(
            React.createElement(
                NestedDropdownMenu,
                {
                    ...menuOptions,
                    ...nestedMenuOptions,
                    toggle: <li>Choose View</li>,
                    key: 'dropdown_menu_view',
                },
                view_menu_items
            )
        )
    }

    let print_menu_items = []

    if (recordId > -1) {
        const printMenuOptions = data.FormDocMap.sort((a, b) => {
            return a.OrderBy - b.OrderBy || a.DocMapFullName < b.DocMapFullName
        })
        printMenuOptions
            .filter((d) => d.DocMapFilename !== '')
            .forEach((docmap, kx) => {
                const printUrl = `${getBaseURL()}webapi/form/recordPrint/${recordId}/${
                    docmap.DocMapFilename
                }/`
                if (docmap.DocTypeId > 0) {
                    print_menu_items.push(
                        React.createElement(
                            'li',
                            {
                                key: `dropdown_menu_print_li${kx}`,
                                onClick: () => handlePrint(printUrl, fieldChanged),
                            },
                            React.createElement(
                                'a',
                                {
                                    key: `dropdown_menu_print_a${kx}`,
                                },
                                docmap.DocMapFullName
                            )
                        )
                    )
                }
            })
    }

    dropdown_menu_items.push(
        React.createElement(
            NestedDropdownMenu,
            {
                ...menuOptions,
                ...nestedMenuOptions,
                toggle: <li>Print</li>,
                key: 'dropdown_menu_print',
            },
            print_menu_items
        )
    )

    if (recordId > 0 && data.OrderInfo && data.OrderInfo[0].OrderTagId > 0) {
        dropdown_menu_items.push(
            React.createElement(
                'li',
                {
                    key: 'dropdown_menu_delete_li',
                },
                React.createElement(
                    'a',
                    {
                        onClick: () =>
                            setCurrentModal(
                                <TimeLogModal
                                    close={() => setCurrentModal(null)}
                                    orderTagId={data.OrderInfo[0].OrderTagId}
                                />
                            ),
                        href: '#',
                        key: 'dropdown_menu_edit_time_a',
                    },
                    'Edit Time Log'
                )
            )
        )
    }
    // 130 is performance reviews
    if (
        recordId > 0 &&
        data.FormSectionFieldValueView[0].RecordStatus === 'N' &&
        !lockState.locked &&
        data.FormSectionFieldValueView[0].FormId !== 130
    ) {
        dropdown_menu_items.push(
            React.createElement(
                'li',
                {
                    key: 'dropdown_menu_delete_li',
                },
                React.createElement(
                    'a',
                    {
                        onClick: () => handleDelete(formId, recordId, currentUser, versionNumber),
                        href: '#',
                        key: 'dropdown_menu_delete_a',
                    },
                    'Delete'
                )
            )
        )
    }

    let section_jump_menu_items = []
    let sections = getSections(data)
    sections.forEach((section, j) => {
        section_jump_menu_items.push(
            React.createElement(
                'li',
                {
                    key: `dropdown_menu_jump_li${j}`,
                },
                React.createElement(
                    'a',
                    {
                        href: `#section${section.FormSectionId}`,
                        key: `dropdown_menu_jump_a${j}`,
                    },
                    section.Section
                )
            )
        )
    })

    dropdown_menu_items.push(
        React.createElement(
            NestedDropdownMenu,
            {
                ...menuOptions,
                ...nestedMenuOptions,
                toggle: <li>Jump To</li>,
                key: 'dropdown_menu_jump',
            },
            section_jump_menu_items
        )
    )

    let lock_menu_items = []
    lock_menu_items.push(
        React.createElement('li', {
            key: 'dropdown_menu_lock_li0',
            className: recordLockLevel === 0 ? 'current-lock-level' : '',
        })
    )
    for (let i = 1; i <= numLevels; i++) {
        lock_menu_items.push(
            React.createElement(
                'li',
                {
                    key: `dropdown_menu_lock_li${i}`,
                },
                React.createElement(
                    'div',
                    {
                        key: `div_lock_${i}`,
                        style: { display: 'flex', alignItems: 'center' },
                        onClick: () => prehandleLock(i, recordLockLevel, null, false),
                    }, // Added container div with flexbox styling
                    React.createElement(
                        'a',
                        {
                            key: 'dropdown_menu_lock_a',
                        },
                        `Level ${i.toString()}`
                    ),
                    Array.isArray(lockedLevelsArray) &&
                        lockedLevelsArray.includes(i.toString()) &&
                        React.createElement(SvgIcon, {
                            icon: lockIcon,
                            svgStyle: { width: '12px', marginLeft: '5px' },
                        })
                )
            )
        )
    }

    if(canUnlock){
        lock_menu_items.push(
            React.createElement(
                'li',
                {
                    key: 'dropdown_menu_lock_li 9',
                },
                React.createElement(
                    'div',
                    {
                        key: 'div_lock_9',
                        style: { display: 'flex', alignItems: 'center' },
                        onClick: () => setShowConfirmModal(true),
                    }, // Added container div with flexbox styling
                    React.createElement(
                        'a',
                        {
                            key: 'dropdown_menu_lock_a',
                        },
                        'Unlock all Levels'
                    ),
                    
                )
            )
        )
    }

    // dont make the lock menu if they are all at level 0
    numLevels > 0 &&
        !lockState.locked &&
        dropdown_menu_items.push(
            React.createElement(
                NestedDropdownMenu,
                {
                    ...menuOptions,
                    ...nestedMenuOptions,
                    toggle: <li>Lock</li>,
                    key: 'dropdown_menu_lock',
                },
                lock_menu_items
            )
        )

    if (refRecordId.current !== -1 && !lockState.locked)
        dropdown_menu_items.push(
            React.createElement(
                'li',
                {
                    onClick: (e) => {
                        handleReadOnly(e)
                    },
                    ...menuOptions,
                    className: 'nested-dd-menu nested-reverse',
                    style: {
                        textAlign: 'left',
                        padding: 4,
                        paddingLeft: 24,
                        fontFamily: 'Roboto, sans-serif',
                    },
                    key: 'dropdown_menu_newrec_a',
                },
                'Read Only Mode'
            )
        )

    return React.createElement(
        DropdownMenu,
        {
            ...menuOptions,
            isOpen: isMenuOpen,
            close: closeMenu,
            toggle: (
                <button
                    key='b1'
                    type='button'
                    className='dropdown-toggle-main'
                    onClick={toggleMenu}
                >
                    {toggle_dropdown_children}
                </button>
            ),
            align: 'right',
            id: 'dropdown_menu',
            key: 'dropdown_menu',
        },
        dropdown_menu_items
    )
}
